var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "section-head" }, [_vm._v("红包配置")]),
      _c(
        "div",
        { staticClass: "red-tiers-actions" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _setup.addRedTier },
            },
            [_vm._v("新增")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticClass: "tier-table red-tier-table",
          attrs: { data: _vm.redTiers, border: "", size: "mini" },
        },
        [
          _c("el-table-column", {
            attrs: { label: "序号", width: "56", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(_vm._s(scope.$index + 1))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "获取到红包个数", "min-width": "240" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    !scope.row.isGuarantee
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              gap: "6px",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "70px" },
                                attrs: { size: "mini" },
                                model: {
                                  value: scope.row.num_interval_type,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      scope.row,
                                      "num_interval_type",
                                      $$v
                                    )
                                  },
                                  expression: "scope.row.num_interval_type",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: "≥",
                                    value: _setup.RED_NUM_INTERVAL_GTE,
                                  },
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: ">",
                                    value: _setup.RED_NUM_INTERVAL_GT,
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("el-input-number", {
                              staticStyle: { width: "90px" },
                              attrs: {
                                min: 0,
                                precision: 0,
                                controls: false,
                                size: "mini",
                              },
                              model: {
                                value: scope.row.num,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "num", $$v)
                                },
                                expression: "scope.row.num",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "奖励类型", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "120px" },
                        attrs: {
                          size: "mini",
                          disabled: scope.row.isGuarantee,
                        },
                        on: {
                          change: function ($event) {
                            return _setup.onRedTierRewardTypeChange(
                              scope.$index
                            )
                          },
                        },
                        model: {
                          value: scope.row.reward_type,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "reward_type", $$v)
                          },
                          expression: "scope.row.reward_type",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: {
                            label: "随机奖励",
                            value: _setup.RED_REWARD_TYPE_RANDOM,
                          },
                        }),
                        _c("el-option", {
                          attrs: {
                            label: "固定奖励",
                            value: _setup.RED_REWARD_TYPE_FIXED,
                          },
                        }),
                        _c("el-option", {
                          attrs: {
                            label: "保底奖励",
                            value: _setup.RED_REWARD_TYPE_GUARANTEE,
                            disabled: !scope.row.isGuarantee,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "奖励数", "min-width": "240" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.reward_type === _setup.RED_REWARD_TYPE_RANDOM
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              gap: "6px",
                            },
                          },
                          [
                            _c("el-input-number", {
                              staticStyle: { width: "92px" },
                              attrs: {
                                min: 0,
                                precision: 2,
                                controls: false,
                                size: "mini",
                              },
                              model: {
                                value: scope.row.reward_count_min,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "reward_count_min", $$v)
                                },
                                expression: "scope.row.reward_count_min",
                              },
                            }),
                            _c(
                              "span",
                              {
                                staticClass: "rule-suffix",
                                staticStyle: {
                                  "font-size": "13px",
                                  color: "#606266",
                                },
                              },
                              [_vm._v("~")]
                            ),
                            _c("el-input-number", {
                              staticStyle: { width: "92px" },
                              attrs: {
                                min: 0,
                                precision: 2,
                                controls: false,
                                size: "mini",
                              },
                              model: {
                                value: scope.row.reward_count_max,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "reward_count_max", $$v)
                                },
                                expression: "scope.row.reward_count_max",
                              },
                            }),
                          ],
                          1
                        )
                      : _c("el-input-number", {
                          staticStyle: { width: "120px" },
                          attrs: {
                            min: 0,
                            precision: 0,
                            controls: false,
                            size: "mini",
                          },
                          model: {
                            value: scope.row.reward_count,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "reward_count", $$v)
                            },
                            expression: "scope.row.reward_count",
                          },
                        }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "库存", width: "170" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "tier-stock-line" },
                      [
                        _c(
                          "el-checkbox",
                          {
                            attrs: {
                              disabled: scope.row.isGuarantee,
                              size: "mini",
                            },
                            model: {
                              value: scope.row.total_unlimited,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "total_unlimited", $$v)
                              },
                              expression: "scope.row.total_unlimited",
                            },
                          },
                          [_vm._v("不限")]
                        ),
                        !scope.row.isGuarantee
                          ? _c("el-input-number", {
                              staticClass: "tier-stock-input",
                              attrs: {
                                disabled: scope.row.total_unlimited,
                                min: 0,
                                precision: 0,
                                controls: false,
                                size: "mini",
                              },
                              model: {
                                value: scope.row.total,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "total", $$v)
                                },
                                expression: "scope.row.total",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "已发放", width: "72", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(_vm._s(scope.row.available_num))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "72", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    !scope.row.isGuarantee
                      ? _c(
                          "el-button",
                          {
                            staticClass: "danger-button",
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _setup.removeRedTier(scope.$index)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }